import { Doc } from "../../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";

/**
 * Regla: filtro por payment status (prioridad 3)
 * Args se deriva automáticamente como Partial<Omit<Doc<"logistics_orders">, "_id" | "_creationTime">>
 */
export const paymentStatusRule: FilterRule<Doc<"logistics_orders">> = {
  priority: 3,
  build: async (ctx, args) => {
    const { userContext, db } = ctx;

    if (!args.paymentStatus) return undefined;

    if (userContext?.companyId) {
      const logistics_orders = await db
        .query("logistics_orders")
        .withIndex("by_company_and_payment_status", (q) =>
          q
            .eq("internalControl.companyId", userContext.companyId!)
            .eq("paymentStatus", args.paymentStatus!),
        )
        .collect();

      return logistics_orders;
    }
  },
};

/**
 * Regla: filtro por shipment (prioridad 4)
 */
export const shipmentFilterRule: FilterRule<Doc<"logistics_orders">> = {
  priority: 4,
  build: async (ctx, args) => {
    const { userContext, db } = ctx;

    if (!args.shipmentId) return undefined;

    if (userContext?.companyId) {
      return await db
        .query("logistics_orders")
        .withIndex("by_company_and_shipment", (q) =>
          q
            .eq("internalControl.companyId", userContext.companyId!)
            .eq("shipmentId", args.shipmentId!),
        )
        .collect();
    }
  },
};
